import { FC } from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import FormSelect from '@components/FormSelect/FormSelect';
import FormTextField from '@components/FormTextField/FormTextField';
import useOrganizations from '@store/hooks/useOrganizations';

import { IUserProfileInitialFormProps } from './UserProfileInitialForm.interface';

import './style.scss';

const UserProfileInitialForm: FC<IUserProfileInitialFormProps> = ({ handleSubmit }) => {
  const { t } = useTranslation();

  const organizations = useOrganizations();

  return (
    <form
      className="user-profile-initial-form"
      id="user-profile-initial-form"
      onSubmit={handleSubmit}
      noValidate
    >
      <p className="user-profile-initial-form__required small">{t('common.required')}</p>

      <Field
        component={FormSelect}
        className="user-profile-initial-form__input"
        label={t('userProfile.organization')}
        name="organizationId"
        options={organizations}
      />

      <Field
        component={FormTextField}
        className="user-profile-initial-form__input"
        label={t('userProfile.organizationAccessCode')}
        name="organizationCode"
        required
      />
    </form>
  );
};

export default UserProfileInitialForm;
